module.exports = __webpack_public_path__ + "img/afiliate-img.c17b7a12.svg";